<div>
  <nav
    ngbNav
    #nav="ngbNav"
    justify="fill"
    [activeId]="type"
    (navChange)="tabChange($event)"
    class="nav-pills"
    >
    <ng-container [ngbNavItem]="'openorders'">
      <a ngbNavLink>
        {{ "OPENORDERS" | translate }}
      </a>
    </ng-container>
    <ng-container [ngbNavItem]="'invoices'">
      <a ngbNavLink>
        {{ (applicationService.getSelectCompanyGroupCode() === 'WG' ? "INVOICES_ALL" : "INVOICES") | translate }}
      </a>
    </ng-container>
    @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
      <ng-container [ngbNavItem]="'credit'">
        <a ngbNavLink>
          {{'CREDIT_INVOICES'|translate}}
        </a>
      </ng-container>
    }
    <ng-container [ngbNavItem]="'packingslips'">
      <a ngbNavLink>
        {{ "PACKINGSLIPS" | translate }}
      </a>
    </ng-container>
    @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
      <ng-container
        [ngbNavItem]="'balance'"
        >
        <a ngbNavLink>
          {{ "BALANCE_LABEL" | translate }}
        </a>
      </ng-container>
    }
    <ng-container
      [ngbNavItem]="'sent_orders'"
      >
      <a ngbNavLink>
        {{ "SENT_ORDERS" | translate }}
      </a>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
